window.addEventListener('load', function () {
  setTimeout(() => {
    console.log('blog.js loaded');

    const rows = document.querySelectorAll('.flex-image-row, .flex-image-row2');

    if (!rows.length) {
      console.log('❌ Nenašiel som žiadny obrázkový blok');
      return;
    }

    rows.forEach(container => {
      const imgs = Array.from(container.querySelectorAll('img'));
      container.innerHTML = '';

      // Rozlíšime si max veľkosť podľa triedy kontajnera
      const isLarge = container.classList.contains('flex-image-row2');
      const maxW = isLarge ? 500 : 317;

      imgs.forEach(img => {
        const wrapper = document.createElement('div');
        wrapper.className = 'img-wrapper';
        wrapper.style.display = 'flex';
        wrapper.style.flexDirection = 'column';
        wrapper.style.alignItems = 'center';
        wrapper.style.flex = `1 1 ${maxW}px`;
        wrapper.style.maxWidth = `${maxW}px`;
        wrapper.style.margin = '0 10px 20px 0';

        // Nastav rozmery obrázka
        img.style.width = `${maxW}px`;
        img.style.height = `${maxW}px`;
        img.style.objectFit = 'cover';
        img.style.borderRadius = '6px';

        wrapper.appendChild(img);

        if (img.alt && img.alt.trim() !== '') {
          const caption = document.createElement('div');
          caption.className = 'img-caption';
          caption.textContent = img.alt;
          caption.style.textAlign = 'center';
          caption.style.fontSize = '0.9rem';
          caption.style.color = '#666';
          caption.style.marginTop = '5px';

          caption.style.display = '-webkit-box';
          caption.style.webkitBoxOrient = 'vertical';
          caption.style.webkitLineClamp = '2';
          caption.style.overflow = 'hidden';

          wrapper.appendChild(caption);
        }

        container.appendChild(wrapper);
      });
    });
  }, 300);
});
